import { useCallback, ReactNode } from 'react';

import { useAuthenticatedUser } from 'features/authentication';

import { PermissionsContext } from './permissions-context';
import { rules, IPermissionRule } from './role-rules';

export function PermissionsProvider({ children }: { children: ReactNode }) {
  const user = useAuthenticatedUser();

  const hasRolePermission = useCallback(
    (permission: IPermissionRule) => rules[permission].includes(user.role),
    [user],
  );

  return (
    <PermissionsContext.Provider value={{ hasRolePermission }}>
      {children}
    </PermissionsContext.Provider>
  );
}
